// extracted by mini-css-extract-plugin
module.exports = {"tabs":"PrimaryTab_tabs__3gCza","tabMaxheightAndWidth":"PrimaryTab_tabMaxheightAndWidth__K_5KK","tab":"PrimaryTab_tab__20fic"};